export const iotColors = {
  red: "#FC5C65",
  yellow: "#FED330",
  green: "#26DE81",
  light_green: "#dded9c",
  black: "#FFFFFF00",
  grey: "#8A8A8A"
};

export const mapColors = {
  red: "#FC5C65",
  yellow: "#FED330",
  green: "#26DE81",
  light_green: "#dded9c",
  black: "#FFF",
  grey: "#8A8A8A",
  // CNC Mode
  manual: "#9d9dff",
  manual_jog: "#9d9dff",
  automatic: "#1414ff",
  edit: "#0080ff",
  semiautomatic: "#000062",
  undefined: "#fff",
  // CNC Status
  ready: "#9d9dff",
  exe: "#1414ff",
  done: "#fff",
  hold: "#0000b1",
  feed_hold: "#0080ff",
  optional_stop: "#000062",
  program_stopped: "#000027"
};

export const mapProductionStateColors = {
  ready: "#fff",
  exe: "#26DE81",
  handling: "#dded9c",
  hold: "#fff",
  fail: "#fff",
  done: "#fff",
  empty: "#fff",
  abort: "#fff",
  setup: "#fff",
  none: "#fff"
};

export const mapStateColors = {
  ready: iotColors.yellow,
  exe: iotColors.green,
  power_off: iotColors.grey,
  fail: iotColors.red,
  disconnected: iotColors.black,
  handling: iotColors.light_green,
  undefined: iotColors.black,
  unknown: iotColors.black,
  setup: iotColors.yellow
};

export const mapStateEnergyColors = {
  default: "#8A8A8A",
  electric: "#026cff",
  pneumatic_air: "#26DE81"
};
